import {Stack, Typography} from '@mui/material';
import {ExamModule, UserModule} from '@cp/model';
import CoursesSelectedModules from './CoursesSelectedModules';

export interface CoursesSelectedProps {
  userModules: UserModule[];
  examModules: ExamModule[];
}

export default function CoursesSelected({userModules, examModules}: CoursesSelectedProps) {
  return (
    <Stack spacing={4} data-testid="your-courses-section">
      <Typography variant="h5" sx={{fontWeight: 600, mb: 2}} data-testid="your-courses-heading">
        Your Courses
      </Typography>
      <CoursesSelectedModules userModules={userModules} examModules={examModules} />
    </Stack>
  );
}
